import { Link } from "gatsby-plugin-react-i18next";
import PropTypes from "prop-types";
import React, { useState } from "react";
import * as styles from "./header.module.scss";
import Logo from "../../../images/logo.svg";
import menu from "../../../icons/menus/MenuHamburguesa.svg";
import upRightArrow from "../../../icons/arrows/upRightArrow.svg";
import { Hamburguer } from "../Hamburguer/Hamburguer";
import AccordionContent from "../AccordionContent/AccordionContent";
import { OpenAndClose } from "../OpenAndClose/OpenAndClose";
import PreHeader from "./PreHeader";
import DropDownRefact from "../DropDownRefact/DropDownRefact";

const Header = ({
  openAndClose,
  isDropDownOpen,
  paises,
  patternCategory,
  childCategory,
  categories
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const [isRotated, setRotated] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isManuallyToggled, setIsManuallyToggled] = useState(false);

  const toggleDropdown = () => {
    if (isManuallyToggled) return; // Evita abrir si se cerró manualmente
    setRotated(!isRotated);
    openAndClose();
  };
  
  const handleLinkClick = () => {
    setIsManuallyToggled(true); // Bloquea el hover al cerrar manualmente
    openAndClose();
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.container__preHeader}>
          <PreHeader color={"black"} colorLupa={"white"} paises={paises} />
        </div>

        <nav className={`${styles.headerNav} container`}>
          <Link to="/">
            <img src={Logo} alt="Logo institucional de Peabody" />
          </Link>

          <div className={styles.menu}>
            <Hamburguer
              src={menu}
              alt="Icono"
              opened={isDropDownOpen}
              clicked={() => toggleDropdown()}
            />
          </div>
          <div className={styles.contectNav}>
            <div className={styles.container_products}  
              onMouseEnter={() => {
                if (!isHovered) {
                  setIsHovered(true);
                  toggleDropdown();
                }
              }}           
            >
              <OpenAndClose
                name={"Productos"}
                toggleDropdown={toggleDropdown}
                isRotated={isDropDownOpen}
              />
            </div>

            <ul className={styles.ulNav}>
              <li>
                <a
                  href="https://tienda.mercadolibre.com.ar/peabody"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Tienda
                </a>
                <img src={upRightArrow} alt="Icono de flecha" />
              </li>
              <li>
                <Link to="https://cultura.peabody.com.ar" target="_blank"> Cultura </Link>
              </li>
              <li>
                <Link to="/historia">Historia</Link>
              </li>
              <li>
                <Link to="/recetas">Recetas</Link>
              </li>
              <li>
                <Link to="/contacto">Contacto</Link>
              </li>
              <li>
                <Link to="/servicio-tecnico">Servicio Técnico</Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <div
        onMouseLeave={() => {
          if (isHovered) {
            setIsHovered(false);
            setIsManuallyToggled(false);
            toggleDropdown();
          }
        }}
      >
        <AccordionContent
          className={styles.accordion}
          color={"white"}
          isOpen={isDropDownOpen}
          patternCategory={patternCategory}
          childCategory={childCategory}
          toggleDropdown={handleLinkClick}
        />
      </div>

      <div className={styles.container__preHeader2}>
        <PreHeader color={"white"} colorLupa={"black"} paises={paises} />
      </div>

      <nav className={`${styles.wrapper} ${isDropDownOpen && styles.active} `}>
        <ul className={`${styles.mobileLinks} `}>
          <li className={`${styles.li__container} container`}>
            <DropDownRefact
              name={"Productos"}
              categories={categories}
              setIsOpened={setIsOpened}
              isOpened={isOpened}
            />
          </li>

          <li className={`${styles.li__container} container`}>
            <div className={styles.container__withImg}>
              <a
                href="https://tienda.mercadolibre.com.ar/peabody"
                className={styles.link}
                onClick={() => setIsOpened(!isOpened)}
              >
                Tienda
              </a>
              <img src={upRightArrow} alt="Icono de flecha" />
            </div>
          </li>

          <li className={`${styles.li__container} container`}>
            <Link
              to="https://cultura.peabody.com.ar" 
              target="_blank"
              className={styles.link}
              onClick={() => setIsOpened(!isOpened)}
            >
              Cultura
            </Link>
          </li>

          <li className={`${styles.li__container} container`}>
            <Link
              to="/historia"
              className={styles.link}
              onClick={() => setIsOpened(!isOpened)}
            >
              Historia
            </Link>
          </li>
          <li className={`${styles.li__container} container`}>
            <Link
              to="/recetas"
              className={styles.link}
              onClick={() => setIsOpened(!isOpened)}
            >
              Recetas
            </Link>
          </li>
          <li className={`${styles.li__container} container`}>
            <Link
              to="/contacto"
              className={styles.link}
              onClick={() => setIsOpened(!isOpened)}
            >
              Contacto
            </Link>
          </li>

          <li className={`${styles.li__container} container`}>
            <Link
              to="/servicio-tecnico "
              className={styles.link}
              onClick={() => setIsOpened(!isOpened)}
            >
              Servicio técnico
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
